import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';

import { useSingleRoot } from './SingleRootContext';

import type { QueryClient } from '@tanstack/react-query';
import type { ReactNode } from 'react';

interface RootQueryProviderProps {
  /** The page's own client, used only when the page is mounted outside the shell. */
  client: QueryClient;
  children: ReactNode;
}

/**
 * A page root's query provider. Outside the single-root shell it provides the page's own
 * client exactly as `QueryClientProvider` does today; inside the shell it renders the
 * children on the shell's one client, so a page adopting it joins the shared cache.
 */
const RootQueryProvider = ({ children, client }: RootQueryProviderProps) => {
  const shell = useSingleRoot();
  if (shell) return <>{children}</>;
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
};

export default RootQueryProvider;
